import { type RefObject, useEffect } from 'react'

import type { NodeOverlay } from './canvasTypes'
import type { GraphLiveAppearance } from './graphInstrumentation'
import {
  graphNodeActivationPolicy,
  listenForGraphNodePointerActivation,
} from './graphNodePointerActivation'
import type { OpenOffPageConnector } from './useOpenOffPageConnector'

export function useGraphNodePointerActivation({
  overlays,
  svgRef,
  containerRef,
  liveValueAppearances,
  onOpenOffPageConnector,
  onSelectFlowNode,
  onSelectNode,
}: {
  overlays: NodeOverlay[]
  svgRef: RefObject<SVGSVGElement>
  containerRef: RefObject<HTMLDivElement>
  liveValueAppearances: GraphLiveAppearance[]
  onOpenOffPageConnector?: OpenOffPageConnector
  onSelectFlowNode?: (overlay: NodeOverlay) => void
  onSelectNode: (overlay: NodeOverlay) => void
}): void {
  useEffect(() => {
    const container = containerRef.current
    const activation = graphNodeActivationPolicy({
      onSelectFlowNode,
      onOpenOffPageConnector,
      onSelectNode,
    })
    if (!container || !overlays.length) return
    return listenForGraphNodePointerActivation(container, {
      overlays,
      getSvg: () => svgRef.current,
      activation,
      liveValueAppearances,
    })
  }, [
    overlays,
    svgRef,
    containerRef,
    onOpenOffPageConnector,
    onSelectFlowNode,
    onSelectNode,
    liveValueAppearances,
  ])
}
